export enum EventLogAction {
  CREATED = "CREATED",
  CANCELLED = "CANCELLED",
  RESCHEDULED = "RESCHEDULED",
  STATUS_CHANGED = "STATUS_CHANGED",
  CHECKED_IN = "CHECKED_IN",
  NO_SHOW_MARKED = "NO_SHOW_MARKED",
  COMPLETED = "COMPLETED",
  PATIENT_CHANGED = "PATIENT_CHANGED",
  PROVIDER_CHANGED = "PROVIDER_CHANGED",
  SERVICE_ADDED = "SERVICE_ADDED",
  SERVICE_REMOVED = "SERVICE_REMOVED",
}
